import React, { useState, useEffect } from "react";
import { classNames } from "../../helpers/classNames";

const Spinner = ({
  divClasses,
  label,
  labelClasses,
  buttonClasses,
  buttonIcon,
  buttonEffect = "filled",
  buttonLabel,
  buttonLabelClasses,
  buttonIconPosition = "left",
  buttonType = "button",
  inputClasses,
  inputPlaceholder,
  inputValue,
  inputName,
  errorType,
  errorText,
  value,
  onChange = () => {},
  isDisable = false,
  isAddDisabled,
}) => {
  const effect = {
    filled:
      "z-0 before:content-[''] before:z-[-1] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-magenta-600/80 before:scale-x-0 before:transition-all before:duration-200 hover:before:scale-x-100 before:origin-left",
    hollow:
      "z-0 before:content-[''] before:z-[-1] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-slate-100 before:scale-x-0 before:transition-all before:duration-200 hover:before:scale-x-100 before:origin-left border border-slate-200 bg-slate-50 hover:border-slate-300",
  };

  const isControlled = value !== undefined && onChange;
  const [num, setNum] = useState(inputValue || 0);

  useEffect(() => {
    if (!isControlled && typeof inputValue === "number") {
      setNum(inputValue);
    }
  }, [inputValue]);

  const currentValue = isControlled ? value : num;

  const updateValue = (newVal) => {
    if (!isControlled) setNum(newVal);
    onChange(newVal);
  };

  const incNum = () => updateValue(currentValue + 1);
  const decNum = () => {
    if (currentValue <= 0) {
      return;
    }
    updateValue(Math.max(0, currentValue - 1));
  };

  const handleChange = (e) => {
    const parsed = parseInt(e.target.value);
    updateValue(Number.isNaN(parsed) ? 0 : parsed);
  };

  const renderError = () => {
    if (!errorType) return null;

    const styles = {
      danger: "text-red-600",
      warning: "text-amber-600",
      success: "text-green-600",
      info: "text-sky-600",
    };

    const icons = {
      danger: "fa-square-exclamation",
      warning: "fa-triangle-exclamation",
      success: "fa-circle-check",
      info: "fa-circle-info",
    };

    return (
      <div className={classNames("text-xs mt-1", styles[errorType])}>
        <i
          className={classNames(
            "fa-regular fa-fw text-sm mr-1",
            icons[errorType]
          )}
        ></i>
        {errorText}
      </div>
    );
  };

  return (
    <>
      {label && (
        <div
          className={classNames(
            "text-sm font-medium text-slate-950 mb-1",
            labelClasses
          )}
        >
          {label}
        </div>
      )}
      <div className={classNames("relative flex", divClasses)}>
        <button
          type={buttonType}
          className={classNames(
            "relative z-[1] w-12 h-12 min-w-[48px] rounded-lg bg-magenta-500 text-white",
            buttonClasses,
            effect[buttonEffect]
          )}
          onClick={decNum}
          disabled={isDisable}
        >
          <i className="fa-regular fa-minus"></i>
        </button>
        <input
          type="number"
          className={classNames("text-center", inputClasses)}
          placeholder={inputPlaceholder}
          name={inputName}
          value={currentValue}
          onChange={handleChange}
          disabled={isDisable}
        />
        <button
          type={buttonType}
          className={classNames(
            "relative z-[1] w-12 h-12 min-w-[48px] rounded-lg bg-magenta-500 text-white",
            isAddDisabled || isDisable ? "cursor-not-allowed opacity-50" : "",
            buttonClasses,
            effect[buttonEffect]
          )}
          onClick={incNum}
          disabled={isAddDisabled || isDisable}
        >
          <i className="fa-regular fa-plus"></i>
        </button>
      </div>
      {renderError()}
    </>
  );
};

export default Spinner;
